import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../../../core/services/role.service';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { ApplicationService } from '../../../../core/services/application.service';
import { AdvertisementService } from '../../../../core/services/advertisement.service';
import { ConfigService } from '../../../../core/utils/config-service';
import { StoreService } from '../../../../core/services/store.service';
import { UserService } from '../../../../core/services/user.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CarouselService } from '../../../../core/services/carousel.service';
import { StatusComponent } from '../../component/status/status.component';

@Component({
  selector: 'app-application',
  standalone: true,
  imports: [
     CommonModule,
                FormsModule,
                NgbModule,
                NgxPaginationModule,
                LoadingComponent,
                SampleSearchPipe,
                NgSelectModule,
                StatusComponent
  ],
  templateUrl: './application.component.html',
  styleUrl: './application.component.css'
})
export class ApplicationComponent {
 buttonsPermission :any|undefined;
 buttonsPermission2 :any|undefined;
  structures:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  data2:any[] =[]
  stores:any[] =[]
  users:any[] =[]
  selectedWindow:any
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="Applications"
  permissionName=""
    search_text=""
role:any
  user:any
  loading2=false
  fileInput:any; 
pg={
    pageSize:10,
    p:0,
    total:0
  }
pg2={
    pageSize:10,
    p:0,
    total:0
  }
  baseUrl=ConfigService.toFile('storage');


  constructor(
    private applicationService:ApplicationService,
    private carouselService:CarouselService,
    private adsService:AdvertisementService,
    private storeService:StoreService,
    private userService:UserService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getAll()
    this.getAll2()
    this.getUsers()
    this.getStores()
  
  }

  getUsers(){
    this.userService.getAll().subscribe((res:any)=>{
      this.users=res.data
    },
    (err:any)=>{

    })
  }
  getStores(){
    this.storeService.getAll().subscribe((res:any)=>{
      this.stores=res.data
    },
    (err:any)=>{

    })
  }
 

  getAll(){
    this.loading2=true

    this.carouselService.getAll().subscribe((res:any)=>{
      this.data=res.data 
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }
  getAll2(){
    this.loading2=true

    this.adsService.getAll().subscribe((res:any)=>{
      this.data2=res.data 
      this.pg2.pageSize=10
      this.pg2.p=0
      this.pg2.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }


  store(value:any){
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
      formData.append('image',this.fileInput)
    }
    this.loading=true
    this.carouselService.store(formData).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  update(value:any){
    this.loading=true
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        formData.append(key,element)
      }
    }

    if (this.fileInput!=undefined) {
      formData.append('image',this.fileInput)
    }
    this.carouselService.update(this.selected_data.id,formData).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.carouselService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
})
  }

  
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  upload(ev:any){
    if (ev.target.files.length!=0) {
      this.fileInput=ev.target.files[0]
    }
  }
 

  getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
    };
    this.buttonsPermission2 = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:AppActionCheck.check(this.tag,'Mettre un statut'),
      print:AppActionCheck.check(this.tag,'Imprimer/Télécharger'),
      transUp:AppActionCheck.check(this.tag,'Transmettre'),
      transDown:AppActionCheck.check(this.tag,'Affecter'),
      sign:AppActionCheck.check(this.tag,'Signer'),
      viewer:AppActionCheck.check(this.tag,'Visualiser Fichier'),
      return:AppActionCheck.check(this.tag,'Retouner pour correction')
    };
  }

  store2(value:any){
    this.loading=true

    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        if (key=="target") {
          formData.append(key,JSON.stringify(element))
        } else {
          formData.append(key,element)

        }
      }
    }

    if (this.fileInput!=undefined) {
      formData.append('image',this.fileInput)
    }
    this.adsService.store(formData).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll2()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des publicités",err)
    })
  }
  update2(value:any){
    this.loading=true
    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
        if (key=="target") {
          formData.append(key,JSON.stringify(element))
        } else {
          formData.append(key,element)

        }
      }
    }

    if (this.fileInput!=undefined) {
      formData.append('image',this.fileInput)
    }
    this.adsService.update(this.selected_data.id,formData).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll2()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des publicités",err)
    })
  }
  delete2(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.adsService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll2()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des publicités",err)
    })
  }
})
  }


  getPage(event:any){
    this.pg.p=event
  }
  getPage2(event:any){
    this.pg2.p=event
  }
}
